import React, { ReactNode } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { useSelector } from 'react-redux';

import { COLOR_THEME } from 'constants/colorThemes';
import { getSpacing } from 'stylesheetB2b';

import { StyledDialog } from './ModalLayout.style';
import CloseButton from '../CloseButton';

const MODAL_LAYOUT_DEFAULT_WIDTH = getSpacing(67);

interface Props {
  isOpen: boolean;
  onClose: () => void;
  hideBackdrop?: boolean;
  width?: string;
  colorTheme?: COLOR_THEME;
  children: ReactNode;
}

const ModalLayout: React.FC<Props> = ({
  isOpen,
  onClose,
  children,
  hideBackdrop = true,
  width = MODAL_LAYOUT_DEFAULT_WIDTH,
  colorTheme = COLOR_THEME.STAFF,
}) => {
  const colors = useSelector(colorsSelector);
  return (
    <StyledDialog
      aria-labelledby='modal-layout'
      open={isOpen}
      onClose={onClose}
      disablePortal
      hideBackdrop={hideBackdrop}
      width={width}
      colortheme={colorTheme}
      colors={colors}
    >
      <CloseButton onClose={onClose} />
      {children}
    </StyledDialog>
  );
};

export default ModalLayout;
